import { render, staticRenderFns } from "./LanguageForm.vue?vue&type=template&id=13a2592f&"
import script from "./LanguageForm.vue?vue&type=script&lang=js&"
export * from "./LanguageForm.vue?vue&type=script&lang=js&"
import style0 from "./LanguageForm.vue?vue&type=style&index=0&id=13a2592f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports